import ImageOne from '../images/ImageOne.jpg';
import ImageTwo from '../images/ImageTwo.jpg';
import ImageThree from '../images/ImageThree.jpg';
import ImageFour from '../images/ImageFour.jpg';



export const SliderData = [
    {
        title: 'Luxury Villa in Bali, Indonesia',
        price: '$4,280,000',
        path: '/homes',
        label: 'View Home',
        image: ImageOne,
        alt: 'House'
    },
    {
        title: 'House in San Jose, California',
        price: '$2,860,000',
        path: '/homes',
        label: 'View Home',
        image: ImageTwo,
        alt: 'House'
    },
    {
        title: 'House in Calabasas, California',
        price: '$8,420,000',
        path: '/homes',
        label: 'View Home',
        image: ImageThree,
        alt: 'House'
    },
    {
        title: 'House in Houston, Texas',
        price: '$5,660,000',
        path: '/homes',
        label: 'View Home',
        image: ImageFour,
        alt: 'House'
    },
]